<form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
  <div class="forgot-form">
    <div class="forgot-form__header">
      <h2 class="forgot-form__title">{{ 'forgotPasswordPage.formTitle' | translate }}</h2>
      <p class="forgot-form__description">{{ 'forgotPasswordPage.formDescription' | translate }}</p>
    </div>

    <div class="forgot-form__input-group">
      <label for="email" class="forgot-form__label">
        {{ 'forgotPasswordPage.emailLabel' | translate }}
      </label>

      <input
        id="email"
        type="email"
        class="forgot-form__input-field"
        formControlName="email"
        [ngClass]="{ 'has-error': emailControl.invalid && emailControl.touched }"
        [placeholder]="'forgotPasswordPage.emailPlaceholder' | translate"
        maxlength="255"
      />

      @if (emailControl.touched && emailControl.errors) {
        <div class="form-err">
          @if (emailControl.errors['required']) {
            <span>
              {{ 'forgotPasswordPage.emailRequiredErr' | translate }}
            </span>
          }
          @if (emailControl.errors['email']) {
            <span>
              {{ 'forgotPasswordPage.emailInvalidErr' | translate }}
            </span>
          }
        </div>
      }

      <div class="form-err">
        {{ errorMessageKey()! | translate }}
      </div>
    </div>

    <div class="forgot-form__actions">
      <button type="submit" class="send-link-btn">
        {{ 'forgotPasswordPage.sendRecoveryLink' | translate }}
      </button>
      <button type="button" class="cancel-btn" (click)="returnToLogin()">
        {{ 'forgotPasswordPage.cancel' | translate }}
      </button>
    </div>
  </div>
</form>
